module.exports = "<div class=\"donut-content\" ></div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxDonut/ctxDonut.template.html
// module id = 184
// module chunks = 0 1